<template>
    <section class="esesja-modal">
        <section class="esesja-modal__wraper">
            <section class="esesja-modal__wraper__header">
                <h3 class="esesja-modal__wraper__header__title">Edytuj głosowanie</h3>
                <button class="esesja-modal__wraper__header__exit-btn"
                        @click=" (e)=>{e.preventDefault(); this.$emit('closeEditVotingNameModal');}">
                    <img src="../../../../../assets/icons/components/exit-btn.svg" />
                </button>
            </section>
            <perfect-scrollbar class="esesja-modal__wraper__body">
                <label class="esesja-modal__wraper__body__label">Nazwa głosowania</label>
                <section class="esesja-modal__row">
                    <input type="text"
                           placeholder="Wpisz nazwę głosowania..."
                           class="esesja-modal__wraper__body__input"
                           v-model="name" />
                </section>

                <section class="esesja-modal__wraper__body__bottom">
                    <button class="esesja-modal__wraper__body__bottom-button"
                            @click="this.$emit('closeEditVotingNameModal')">
                        Anuluj
                    </button>
                    <button class="
                        esesja-modal__wraper__body__bottom-button
                        esesja-modal__wraper__body__bottom-button--red
                    "
                            @click="handleSaveClick" :disabled="name.length == 0">
                        Zapisz
                    </button>
                </section>
            </perfect-scrollbar>

        </section>
        <LoaderInside v-if="isLoading" />
    </section>
</template>

<script>
import LoaderInside from "../../../../BasicControls/LoaderInside.vue";
import VotingService from "../../../../../services/voting.service";

export default {
    name: "EditVotingNameModal",
    data() {
        return {
            name: this.tempVotingNameToEdit,
            isLoading: false,
        };
    },
    props: {
        tempVotingNameToEdit: String,
        tempVotingId: Number,
        pointID: Number,
        session: Number
    },
    components: {
        LoaderInside,
    },
    methods: {
        handleSaveClick() {
            this.isLoading = true;
            const data = {
                id: this.tempVotingId,
                name: this.name,
                sid: this.session
            };

            VotingService.editVotingName(this.pointID, data).then(() => {
                this.name = "";
                this.$emit("reload");
                this.$emit("closeEditVotingNameModal");
                this.isLoading = false;
            });
        },
    },
};
</script>

<style lang="scss" scoped>
    @import "../../../../../assets/scss/esesja-modal.scss";
</style>

